export default "__VITE_ASSET__DcIWb$Nk__"